export const ANALYTICS = {
  contactUsSubscriptionLinkId: "contactUs_subscription",
};
